import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import noop from 'lodash/noop';
import { colors, font, space } from 'nicollet-tokens';

const CloseLink = ({
  className,
  href,
  onClick = noop,
  onFocus
}) => jsx("a", Object.assign({
  className: className,
  href: `#${href}`,
  onClick: e => {
    e.preventDefault();
    onClick(e);
  },
  onFocus: onFocus
}, {
  children: "close list"
}), void 0);

CloseLink.displayName = 'CloseLink';
var CloseLink$1 = styled(CloseLink)`
  color: white;
  line-height: 0;
  height: 0;
  padding: 1px 0;
  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  pointer-events: none;
  overflow: hidden;

  &:focus {
    outline: 0;
    color: ${colors.link.onLight.focus};
    border-top: 1px solid ${colors.border.separator.default};
    line-height: ${font.lineHeight.text};
    height: auto;
    padding: ${space.generic.x2} 0 ${space.generic.x2};
    pointer-events: auto;
    overflow: visible;

    &::before {
      content: '';
      outline: 0;
      background: ${colors.palette.gray.darkest};
      height: 5px;
      width: 5px;
      border-radius: 100%;
      position: absolute;
      top: 45%;
      top: calc(50% - 2.5px);
      left: -10px;
    }
  }
`;

export { CloseLink$1 as default };
